



















































































































































import { Vue, Component, Prop, Watch } from "vue-property-decorator";
import { parse } from "papaparse";
import BaseView from "@/components/BaseView.vue";
import BaseDataForm from "@/components/batch/BaseDataForm.vue";
import { RawBatch, RawRequestBody, RawRequest } from "@/store/batch/types";
import RequestList from "@/components/batch/RequestList.vue";
import NewBatchSummary from "@/components/batch/NewBatchSummary.vue";
import DynamicForm from "@/components/form/DynamicForm.vue";
import { RequestResource } from "@/store/request/types";
import { InputTypes } from "@/store/form/types";
import GenerateStep from "@/components/request/GenerateStep.vue";
import SignStep from "@/components/request/SignStep.vue";

@Component({
  components: {
    BaseView,
    DynamicForm,
    GenerateStep,
    SignStep
  }
})
export default class RequestDetail extends Vue {
  // Vuex store with lightweight typed wrapper
  readonly store = this.$store.direct;
  // Component constants
  readonly title = "Solicitud";
  readonly subtitle = "Completa los formularios y firma los documentos";
  readonly info = null;
  // Component variables
  step: number = 1;
  open = false;

  async mounted() {
    this.store.commit.form.CLEAR_SELECTED();
    this.store.commit.request.CLEAR_SELECTED();
    // Fetch selected request
    await this.store.dispatch.request.find(this.$route.params.id);

    let obj: { [key: string]: InputTypes } = {};
    if (this.request) {
      this.request.relationships.templates.data.forEach(template => {
        template.attributes.sections.forEach(section => {
          section.inputs.forEach(input => {
            if (input.type == "radio" || input.type == "checkbox") {
              obj[input.name.toLowerCase()] = false;
            }
            if (input.type == "table") {
              obj[input.name.toLowerCase()] = [];
            }
          });
        });
      });
    }
    // Assign request preloaded variables into template forms
    if (this.store.state.request.selected) {
      this.store.state.request.selected.attributes.variables.forEach(
        variable => {
          obj[variable.name.toLowerCase()] = variable.value;
        }
      );
      if (
        this.admin ||
        this.store.state.request.selected.meta.state != "pending"
      ) {
        this.step =
          this.store.state.request.selected.relationships.templates.data
            .length + 2;
      }
    }

    this.store.commit.form.UPDATE_SELECTED(obj);
  }
  // Component methods
  get request() {
    return this.store.state.request.selected;
  }

  get templates() {
    return this.request
      ? this.request.relationships.templates.data.reverse()
      : [];
  }

  get admin() {
    return this.store.state.session.user
      ? this.store.state.session.user.attributes.is_admin
      : false;
  }

  cancel() {
    this.store.commit.form.CLEAR_SELECTED();
    this.store.commit.request.CLEAR_SELECTED();
    this.$router.back();
  }

  async generate() {
    if (this.request) {
      await this.store.dispatch.request.generate(this.request.id);
      this.step++;
    }
  }

  async sign() {
    if (this.request) {
      let res = await this.store.dispatch.request.sign(this.request.id);
      if (res.data) {
        this.store.commit.PUSH_MESSAGE({
          message: "Los documentos han sido firmados.",
          type: "success"
        });
        this.open = false;
        this.$router.push({ path: "/requests" });
      } else {
        this.open = false;
        this.store.commit.PUSH_MESSAGE({
          message:
            "Al menos un documento no pudo ser firmado. Intente nuevamente.",
          type: "error"
        });
      }
    }
  }
}
